import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AppModule } from './app.module';
import { InactivityService } from './_helpers/inactivity-check-service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AppModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {

  constructor(
  private router: Router,
  private inactivityService: InactivityService
) {
  this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      
      const url = event.urlAfterRedirects;

      // All public (no inactivity tracking here)
      const publicRoutes = [
        '/auth/login',
        '/auth/signup',
        '/auth/otp-verify',
        '/auth/email-verify',
        '/auth/reset-password'
      ];

      if (publicRoutes.includes(url)) {
        this.inactivityService.stop();
      } 
      else {
        this.inactivityService.start();
      }

    }
  });
}

}
